import React from 'react';
import RoutesComponent from './routes';

const App = () => {
  return <RoutesComponent />;
};

export default App;